"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _Img = _interopRequireDefault(require("./Img"));

var _default = _Img.default;
exports.default = _default;